/*!

=========================================================
* Argon Dashboard React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { connect } from "react-redux";
import { getProfile } from "../actions/user";
import { Route, Switch, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// reactstrap components
import { Container } from "reactstrap";
// core components
import Sidebar from "../components/Sidebar/Sidebar.jsx";

import routes from "../routes.js";
import PageNotFound from "../views/PageNotFound";
import ArticlesEdit from "../views/articles/Edit.jsx";
import ArticlesNew from "../views/articles/New.jsx";
import VideoEdit from "../views/videos/Edit.jsx";
import VideoNew from "../views/videos/New.jsx";
import CatAdvEdit from "../views/catadvs/Audit.jsx";
import CatAdvNew from "../views/catadvs/New.jsx";
import BusinessEdit from "../views/busadvs/Edit.jsx";
import BusinessNew from "../views/busadvs/New.jsx";
import FreelancerEdit from "../views/otherarticles/Edit.jsx";
import YellowEdit from "../views/yellowpages/Edit.jsx";
import YellowNew from "../views/yellowpages/New.jsx";

import { Helmet } from "react-helmet";
// import Profile from "../views/profile/Edit.jsx";
// import Subscription from "../views/profile/Sub.jsx";
// import UserArticles from "../views/profile/Articles.jsx";
// import UserArticlesEdit from "../views/profile/EditArticle.jsx";
// import UserArticlesNew from "../views/profile/NewArticle.jsx";
// import UserForums from "../views/profile/Forums.jsx";
// import UserForumEdit from "../views/profile/EditForum.jsx";
// import UserForumNew from "../views/profile/NewForum.jsx";
// import UserAdvs from "../views/profile/Advs.jsx";
// import UserAdvEdit from "../views/profile/EditAdv.jsx";
// import UserAdvNew from "../views/profile/NewAdv.jsx";

const Close = ({ closeToast }) => (
  <button className="close" aria-label="Close" onClick={closeToast}>
    <span aria-hidden="true">×</span>
  </button>
);

class Admin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getProfile("admin");
  }

  componentDidUpdate(e) {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.mainContent.scrollTop = 0;
  }
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.layout === "/dash/admin") {
        return (
          <Route
            exact
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  getBrandText = path => {
    for (let i = 0; i < routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };
  render() {
    let { selectedUser } = this.props.user;
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>管理員客戶端 - 美南新聞</title>
          {/* <link rel="canonical" href="https://soonbus.com/login" /> */}
        </Helmet>
        <Sidebar
          {...this.props}
          routes={routes}
          logo={{
            innerLink: "/",
            imgSrc: require("../assets/img/brand/logo.png"),
            imgAlt: "..."
          }}
          selectedUser={selectedUser}
        />
        <div className="main-content" ref="mainContent">
          <ToastContainer autoClose={6 * 1000} closeButton={<Close />} />
          <Switch>
            {this.getRoutes(routes)}
            <Route
              exact
              path="/dash/admin/articles/:id/edit"
              component={ArticlesEdit}
            />
            <Route
              exact
              path="/dash/admin/articles/new"
              component={ArticlesNew}
            />
            <Route
              exact
              path="/dash/admin/videos/:id/edit"
              component={VideoEdit}
            />
            <Route exact path="/dash/admin/videos/new" component={VideoNew} />
            <Route
              exact
              path="/dash/admin/category-advertisements/:id/edit"
              component={CatAdvEdit}
            />
            <Route
              exact
              path="/dash/admin/category-advertisements/new"
              component={CatAdvNew}
            />
            <Route
              exact
              path="/dash/admin/business-advertisements/:id/edit"
              component={BusinessEdit}
            />
            <Route
              exact
              path="/dash/admin/business-advertisements/new"
              component={BusinessNew}
            />
            <Route
              exact
              path="/dash/admin/other-articles/:id/edit"
              component={FreelancerEdit}
            />
            <Route
              exact
              path="/dash/admin/yellow-pages/:id/edit"
              component={YellowEdit}
            />
            <Route
              exact
              path="/dash/admin/yellow-pages/new"
              component={YellowNew}
            />
            {/* <Route exact path="/admin/profile" component={Profile} />
            <Route exact path="/admin/subscription" component={Subscription} />
            <Route
              exact
              path="/admin/management/articles"
              component={UserArticles}
            />
            <Route
              exact
              path="/admin/management/articles/:id/edit"
              component={UserArticlesEdit}
            />
            <Route
              exact
              path="/admin/management/articles/new"
              component={UserArticlesNew}
            />
            <Route
              exact
              path="/admin/management/forums"
              component={UserForums}
            />
            <Route
              exact
              path="/admin/management/forums/:id/edit"
              component={UserForumEdit}
            />
            <Route
              exact
              path="/admin/management/forums/new"
              component={UserForumNew}
            />
            <Route exact path="/admin/management/advs" component={UserAdvs} />
            <Route
              exact
              path="/admin/management/advs/:id/edit"
              component={UserAdvEdit}
            />
            <Route
              exact
              path="/admin/management/advs/new"
              component={UserAdvNew}
            /> */}
            <Route component={PageNotFound} />
          </Switch>

          <Container fluid></Container>
        </div>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: state.user,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getProfile: params => dispatch(getProfile(params))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Admin);
